import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'assets/sass/app.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'containers/App';
import store from 'redux/store';
import * as serviceWorker from './serviceWorker';
import 'utils/interceptorsService';
import { initGTM } from 'plugins/gtmService';
import { ConfigProvider } from 'antd'; // antd 全域配置
import zhTW from 'antd/es/locale/zh_TW'; // 台灣時區、繁中語系
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Taipei');

initGTM();

ReactDOM.render(
  <ConfigProvider locale={zhTW}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
